import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrganizationService } from '../services/organization.service';
import { Organization } from '../models/organization';

@Component({
  selector: 'app-incada-information',
  templateUrl: './incada-information.component.html',
  styleUrls: ['./incada-information.component.scss'],
  standalone: false
})
export class IncadaInformationComponent implements OnInit {
  get isParentOrg(): boolean { return this.organization?.is_Parent_Account; }
  get resourceType(): string { return this.isParentOrg ? 'Organization' : 'Site'; }

  organization: Organization;
  sites: Organization[] = [];

  constructor(private readonly activatedRoute: ActivatedRoute,
    private readonly organizationService: OrganizationService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe(({ id }) => {
      this.loadOrganizationDetails(id);
    });
  }

  loadOrganizationDetails(id: any) {
    this.organizationService.getByID(id).subscribe({
      next: (org) => {
        this.organization = org;

        if (this.organization.is_Parent_Account) {
          this.organizationService.getSitesByParentOrgId(org.organizationId).subscribe({
            next: (sites) => {
              this.sites = sites;
            },
            error: (err) => {
              console.error(`Error fetching sites for parent organization: ${err}`);
            }
          });
        }
      },
      error: (err) => {
        console.error(`Error fetching organization details: ${err}`);
      }
    });
  }
}
